import React from "react";
import { WintIconProps } from "models/propTypes/iconPropTypes";
import { CSSHelper } from "utils/helpers";
import clsx from "clsx";
import cssExports from "theme/styles/main.module.scss";

const Icon: React.FC<WintIconProps> = (props) => {
  const width = props.icon.width ?? 24;
  const height = props.icon.height ?? 24;

  const rootCss = clsx(
    cssExports.iconRoot,
    props.className,
    props.displayType ? CSSHelper.getClassByDisplayType(props.displayType) : ""
  );

  return (
    <>
      <svg
        aria-hidden="true"
        focusable="false"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        className={rootCss}
        transform={props.icon.transform}
        x={props.icon.x}
        y={props.icon.y}
        dangerouslySetInnerHTML={
          props.icon.content
            ? {
                __html: props.icon.content,
              }
            : undefined
        }
      >
        {props.icon.content ? undefined : props.icon.path instanceof Array ? (
          props.icon.path.map((p, index) => <path key={index} d={p} />)
        ) : (
          <path d={props.icon.path} />
        )}
      </svg>
    </>
  );
};

export default Icon;
